// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({
    id: '',
    name: '',
    imoNumber: '',
    portOfRegistry: '',
    officialNumber: '',
    flag: '',
    coastal: '',
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
  useEffect(() => {

    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');

        try {
          const response = await apiClient.get(`/api/admin/vessel/${invoiceId}`, {

            headers: {
              'access_token': token,
            },

          });
          if (response.data.Status === "SUCCESS") {

            setFormData({
              id: invoiceId || '',
              name: response.data.data.name || '',
              imoNumber: response.data.data.imoNumber || '',
              portOfRegistry: response.data.data.portOfRegistry || '',
              officialNumber: response.data.data.officialNumber || '',
              flag: response.data.data.flag || '',
              coastal: response.data.data.coastal || '',
            });
          }
          else {
            console.log(response.data.message)
          }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };

    fetchInvoiceData();
  }, [invoiceId, edit]);


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/vessel/update`, formData, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };

  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Vessel
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="name" className="label-custom">Name</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="imoNumber" className="label-custom">IMO Number</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="imoNumber"
                        name="imoNumber"
                        value={formData.imoNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="portOfRegistry" className="label-custom">Port Of Registry</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="portOfRegistry"
                        name="portOfRegistry"
                        value={formData.portOfRegistry}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="officialNumber" className="label-custom">Official Number</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="officialNumber"
                        name="officialNumber"
                        value={formData.officialNumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="flag" className="label-custom">Flag</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="flag"
                        name="flag"
                        value={formData.flag}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="coastal" className="label-custom">Coastal</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="coastal"
                        name="coastal"
                        value={formData.coastal}
                        onChange={handleChange}
                      />
                    </div>
                  </div>


                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
